<script setup lang="ts">
import ProgressSpinner from 'primevue/progressspinner';
import type { ShipmentExceptionRow } from '@gpx-spa/queries/src/shipment-exception-types';
import type { NamedTracker } from '@/utils/named-tracker-set';
import ShipmentExceptionEntityCard from '@/components/shipment/detail/cards/ShipmentExceptionEntityCard.vue';
import {
  PVT_SPINNER_STROKE_WIDTH,
  PVT_SPINNER_STYLE_OVERLAY,
} from '@/constants/progress-spinner';

defineProps<{
  exceptions: ShipmentExceptionRow[];
  isLoading: boolean;
  isError: boolean;
  devices?: NamedTracker[];
}>();
</script>

<template>
  <div class="space-y-2">
    <div v-if="isLoading" class="flex justify-center py-8">
      <ProgressSpinner
        :style="PVT_SPINNER_STYLE_OVERLAY"
        :stroke-width="PVT_SPINNER_STROKE_WIDTH"
      />
    </div>

    <p v-else-if="isError" class="text-sm text-red-600">
      Could not load exceptions.
    </p>

    <template v-else>
      <ShipmentExceptionEntityCard
        v-for="row in exceptions"
        :key="row.id"
        :row="row"
        :devices="devices"
      />
      <p v-if="exceptions.length === 0" class="text-sm text-neutral-600">
        No exceptions.
      </p>
    </template>
  </div>
</template>
